import React, { useState, useEffect, useRef } from 'react';
const ClockRenderer = ({ styleType, format = 'HH:mm:ss', offsetMinutes = 0, timeZone = 'Local', showSeconds = true }) => {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);


  // Apply timezone and offset
  let displayTime = new Date(now.getTime() + offsetMinutes * 60000);

  if (timeZone !== 'Local') {
    const localeTimeString = displayTime.toLocaleString('en-US', { timeZone });
    displayTime = new Date(localeTimeString);
  }

  // Format time based on props
  const formatTime = () => {
    const pad = n => n.toString().padStart(2, '0');
    const hrs = pad(displayTime.getHours());
    const mins = pad(displayTime.getMinutes());
    const secs = pad(displayTime.getSeconds());

    if (format === 'HH:mm') return `${hrs}:${mins}`;
    if (format === 'HH:mm:ss') return `${hrs}:${mins}:${secs}`;
    return `${hrs}:${mins}:${secs}`;
  };

  if (styleType === 'Analogue') {
  const secondDeg = displayTime.getSeconds() * 6;
  const minuteDeg = displayTime.getMinutes() * 6 + displayTime.getSeconds() * 0.1;
  const hourDeg = (displayTime.getHours() % 12) * 30 + displayTime.getMinutes() * 0.5;

  const clockSize = 200;

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          width: `${clockSize}px`,
          height: `${clockSize}px`,
          borderRadius: '50%',
          border: '4px solid #333',
          position: 'relative',
          backgroundColor: '#fff',
        }}
      >
        {/* Hour marks (1 to 12) */}
        {Array.from({ length: 12 }).map((_, i) => {
          const angle = (i + 1) * 30;
          const rad = (angle - 90) * (Math.PI / 180);
          const x = (clockSize / 2) + Math.cos(rad) * (clockSize / 2 - 25);
          const y = (clockSize / 2) + Math.sin(rad) * (clockSize / 2 - 25);
          return (
            <div
              key={i}
              style={{
                position: 'absolute',
                left: x - 8,
                top: y - 8,
                width: 16,
                height: 16,
                textAlign: 'center',
                fontSize: 14,
                fontWeight: 'bold',
                color: '#000',
              }}
            >
              {i + 1}
            </div>
          );
        })}

        {/* Hour hand */}
        <div
          style={{
            position: 'absolute',
            width: '4px',
            height: `${clockSize / 4}px`,
            backgroundColor: '#000',
            top: `${clockSize / 2 - clockSize / 4}px`,
            left: `${clockSize / 2 - 2}px`,
            transformOrigin: 'bottom center',
            transform: `rotate(${hourDeg}deg)`,
          }}
        />

        {/* Minute hand */}
        <div
          style={{
            position: 'absolute',
            width: '3px',
            height: `${clockSize / 2.8}px`,
            backgroundColor: '#007bff',
            top: `${clockSize / 2 - clockSize / 2.8}px`,
            left: `${clockSize / 2 - 1.5}px`,
            transformOrigin: 'bottom center',
            transform: `rotate(${minuteDeg}deg)`,
          }}
        />

        {/* Second hand */}
        {showSeconds && (
          <div
            style={{
              position: 'absolute',
              width: '2px',
              height: `${clockSize / 2.2}px`,
              backgroundColor: '#dc3545',
              top: `${clockSize / 2 - clockSize / 2.2}px`,
              left: `${clockSize / 2 - 1}px`,
              transformOrigin: 'bottom center',
              transform: `rotate(${secondDeg}deg)`,
            }}
          />
        )}

        {/* Clock center circle */}
        <div
          style={{
            position: 'absolute',
            width: 10,
            height: 10,
            borderRadius: '50%',
            backgroundColor: '#000',
            top: `${clockSize / 2 - 5}px`,
            left: `${clockSize / 2 - 5}px`,
          }}
        />
      </div>
    </div>
  );
}

  if (styleType === 'Flip') {
    return (
      <div style={{
        width: '100%',
        height: '100%',
        backgroundColor: '#000',
        color: '#00ff00',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '2em',
        fontFamily: 'monospace'
      }}>
        {formatTime()}
      </div>
    );
  }

  // Default: Digital
  return (
    <div style={{
      width: '100%',
      height: '100%',
      backgroundColor: '#000',
      color: '#00ff00',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '2.5em',
      fontFamily: 'monospace'
    }}>
      {formatTime()}
    </div>
  );
};
export default ClockRenderer;